"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFacilityConfigImportable = exports.DEFAULT_MFD_NAME = void 0;
// Every facility is created with this service, which an import reuses for its first one
exports.DEFAULT_MFD_NAME = 'Accueil';
// A configuration is only applied to an empty facility: re-importing over an active one is not handled
var isFacilityConfigImportable = function (mf) {
    return mf.mfus.length === 0 && mf.mfds.length <= 1 && mf.mfds.every(function (mfd) { return mfd.name === exports.DEFAULT_MFD_NAME; });
};
exports.isFacilityConfigImportable = isFacilityConfigImportable;
//# sourceMappingURL=importable.js.map